import React from 'react'
import Head from 'next/head'

import { renderFavicons } from '@awazevr/design-system.components.mfe-head-common'

import { setBackButtonConfig } from '@/utils/helpers'
import { typeCheckBrand } from '@/utils/typeCheckBrand'

interface ICustomHead {
  brand: string
  pageMetaTitle: string
  pageMetaDescription: string
}

export const CustomHead: React.FC<ICustomHead> = ({
  brand,
  pageMetaTitle,
  pageMetaDescription,
}) => {
  setBackButtonConfig()

  return (
    <Head>
      <title>{pageMetaTitle}</title>
      <meta name="robots" content="noindex" />
      <meta name="description" content={pageMetaDescription} />

      <link rel="preconnect" href="https://static.age.awaze.com" />
      <link rel="preconnect" href="https://www.googletagmanager.com" />

      <link rel="preconnect" href="https://app.usercentrics.eu" />
      <link rel="dns-prefetch" href="https://app.usercentrics.eu" />
      {typeCheckBrand(brand) && renderFavicons(brand)}
      <link rel="preconnect" href="https://fonts.gstatic.com" />

      <link
        href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500&family=Poppins:wght@600&display=swap&family=Hind:wght@500;600&display=swap"
        rel="stylesheet"
      />
    </Head>
  )
}
